<template>
  <div>
    <div class="pt-8 text_color">{{ $t("newUi.adminViewform.editCat") }}</div>
    <v-container class="padding_view desktop_section">
      <v-text-field
        v-model="Name"
        v-bind:label="$t('newUi.addCategory.name')"
        v-bind:value="payload.name"
        @input="categoryChange($event)"
        v-bind:title="$t('')"
        autocomplete="off"
        required
      ></v-text-field>
      <div class="mobile_data desktop_section_button">
        <v-btn
          @click.prevent="add_category_submit()"
          class="button_padding cursor-pointer"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.save") }}
        </v-btn>
        <v-btn
          @click.prevent="cancel"
          class="button_padding desktopView cursor-pointer"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.cancel") }}
        </v-btn>
        <!-- <div @click.prevent="add_category_more(name, description)" class="text-decoration-underline cursor text_color">save and add more</div> -->
      </div>
    </v-container>
  </div>
</template>
<script>
import router from "../router/router";
import { saveFile, setLocale } from "../services/firebase";
import { saveMasterData } from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
export default {
  props: ["payload"],

  data() {
    return {
      sheet: false,
      add_category: false,
      name: "",
      category_name: "",
      cat_flag: false,
      cropped: null,
      cropDialog: false,
      croppieElm: null,
      Name: this.payload.name,
      Previous_name: this.payload.name,
    };
  },
  mounted() {
    setLocale();
  },
  computed: {
    type: function() {
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },
  },
  methods: {
    categoryChange: function(event) {
      this.cat_flag = true;
      this.category_name = event;
    },
    add_catag: function() {
      if (
        this.cat_flag == true &&
        this.category_name == "" &&
        this.payload.name != ""
      ) {
        alert(i18n.t("alertText.nameAlert"));
      } else if (this.category_name == "") {
        let list = this.$store.state.currentForm.catalogue;
        for (var item = 0; item < list.length; item++) {
          if (list[item].pos == this.payload.pos) {
            this.$store.state.currentForm.catalogue[item] = this.payload;
            if (
              router.currentRoute.fullPath ==
              "/admin/viewform/" + this.$store.state.currentForm.pos
            ) {
              this.saveCurrentForm();
            } else {
              this.saveCurrentFormRoute();
            }
          }
        }
      } else if (this.category_name != "") {
        let list = this.$store.state.currentForm.catalogue;
        for (var p_item = 0; p_item < list.length; p_item++) {
          if (list[p_item].category == this.payload.name) {
            this.$store.state.currentForm.catalogue[
              p_item
            ].category = this.category_name;
          }
        }
        for (var c_item = 0; c_item < list.length; c_item++) {
          if (list[c_item].pos == this.payload.pos) {
            this.payload.name = this.category_name;
            this.$store.state.currentForm.catalogue[c_item] = this.payload;
          }
        }
        if (
          router.currentRoute.fullPath ==
          "/admin/viewform/" + this.$store.state.currentForm.pos
        ) {
          this.saveCurrentForm();
        } else {
          this.saveCurrentFormRoute();
        }
      }
    },
    set_category_item_null() {
      this.name = "";
    },
    add_category_submit: function() {
      var exists = false;
      if (this.Name.length > 25 || this.category_name.length > 25) {
        alert(i18n.t("alertText.catFormMax"));
      } else {
        this.$store.state.currentForm.catalogue.map((each_category) => {
          if (each_category.type == "category") {
            if (
              this.Previous_name.toLowerCase().replace(/ /g, "") !=
                this.Name.toLowerCase().replace(/ /g, "") &&
              each_category.name.toLowerCase().replace(/ /g, "") ===
                this.Name.toLowerCase().replace(/ /g, "")
            ) {
              exists = true;
            }
          }
        });
        if (exists) alert(i18n.t("alertText.CategoryExists"));
        else {
          this.add_catag();
        }
      }
      // this.add_category = false
      // router.go()
    },
    cancel: function() {
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    add_category_more: function(name) {
      this.add_catag(name);
      this.saveCurrentForm();
      this.set_category_item_null();
      this.add_category = true;
    },
    saveCurrentFormRoute: function() {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
            } else {
              // alert(i18n.t("alertText.uploadText"));
              store.dispatch("setOverlay", false);
              // router.go()
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
        });
      }
    },
    saveCurrentForm: function() {
      console.log("saveCurrentForm edit category");

      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
            } else {
              // alert(i18n.t("alertText.uploadText"));
              store.dispatch("setOverlay", false);
              router.go();
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.button_padding {
  margin-right: 10px;
  color: white !important;
  padding: 10px;
  font-weight: bold;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  text-transform: none;
  cursor: pointer;
}

.bottom_modal {
  border-top-right-radius: 20px !important;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
@media (min-width: 960px) {
  .desktop_section {
    margin-top: 120px;
  }
  .desktop_section_button {
    margin-top: 100px;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .mobile_data {
    text-align: center;
  }
  .desktop_section_button {
    margin-top: 30px;
    margin-bottom: 10px;
  }
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
</style>
